
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 45.6 46"}},[_c('path',{attrs:{"d":"M45.6 20.5h-36l16.9-17L23 0 0 23l23 23 3.5-3.6L9.6 25.5h36z"}})])
      }
    
      }
    